import { useSelector } from 'react-redux';
import { userDetailsSelector } from '../selectors/selectors';

export const useUserInfo = () => {
  const userInfo = useSelector(userDetailsSelector);
  return userInfo;
};
